import Register from './PopupRegister';

const Popup = {
	show: (src, caller) => {
		$.magnificPopup.open({
			fixedContentPos: false,
			items: {
				src: src,
				type: 'inline'
			},
			callbacks: {
				beforeOpen: () => {
					if (typeof caller != 'undefined')
						Register.push({caller: caller, target: src});
				},
				beforeClose: () => {
					if (! Popup.data.src)
						return;

					for (let key in Popup.data.defaults) {
						if (Popup.data.defaults[key] === null)
							$(Popup.data.src).find('[name="' + key + '"]').remove();
						else
							$(Popup.data.src).find('[name="' + key + '"]').val(Popup.data.defaults[key]);
					}

					Popup.data.src = null;
					Popup.data.defaults = new Object();
				},
				afterClose: () => {
					if (typeof caller != 'undefined')
						Register.pop();
				}
			}
		});
	},
	close: () => {
		$.magnificPopup.close();

		return Popup;
	},
	data: {
		src: null,
		defaults: {}
	},
	error: (msg, caller) => {
		$('#popup-error').find('.msg').text(msg);
		Popup.show('#popup-error', caller);
	}
}

export default Popup